import { render, staticRenderFns } from "./Seats.vue?vue&type=template&id=9da49aca&scoped=true"
import script from "./Seats.vue?vue&type=script&lang=js"
export * from "./Seats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da49aca",
  null
  
)

export default component.exports